























































import { Component, Vue, Prop } from "vue-property-decorator";
import { HomeTitle, Round, SimpleImg } from "../index";
import { _isMobile } from "@/libs/tools";

@Component({
    components: {
        HomeTitle,
        Round,
        SimpleImg
    }
})
export default class SecondStage extends Vue {
    @Prop() readonly item: any;
    private flowUrl: string = "";
    mounted() {
        this.flowUrl = _isMobile()
            ? this.item.content.flow.mobile
            : this.item.content.flow.pc;
    }
}
